module.exports = __webpack_public_path__ + "assets/img/lianzi5.cca543a4.jpg";